import React, { useEffect, useState, FormEvent } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Formulario, { FormField } from "../../../components/Formulario";
import {
  getFerramentaById,
  updateFerramenta,
} from "../../../api/ferramentasApi";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { todaEmpresa } from "../../../types/ferramenta";

const EditarFerramenta: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [nomeFerramenta, setNomeFerramenta] = useState<string>("");
  const [nomeTokenFerramenta, setNomeTokenFerramenta] = useState<string>("");
  const [habilidadeFerramenta, setHabilidadeFerramenta] = useState<string>("");
  const [empresas, setEmpresas] = useState<todaEmpresa[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [updating, setUpdating] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFerramenta = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const ferramentaData = await getFerramentaById(token, id!);
        setNomeFerramenta(ferramentaData.nome_ferramenta);
        setNomeTokenFerramenta(ferramentaData.nome_token_ferramenta);
        setHabilidadeFerramenta(ferramentaData.habilidade_ferramenta);
        setEmpresas(ferramentaData.empresas);
      } catch (error) {
        toast.error("Erro ao buscar ferramenta!");
        console.error("Erro ao buscar ferramenta:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFerramenta();
  }, [id]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setUpdating(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }

      await updateFerramenta(token, id!, {
        nome_ferramenta: nomeFerramenta,
        nome_token_ferramenta: nomeTokenFerramenta,
        habilidade_ferramenta: habilidadeFerramenta,
      });
      toast.success("Ferramenta atualizada com sucesso!");
      navigate("/ferramenta");
    } catch (error) {
      toast.error("Erro ao atualizar Ferramenta!");
      console.error("Erro ao atualizar Ferramenta:", error);
    } finally {
      setUpdating(false);
    }
  };

  const handleBack = () => {
    navigate("/ferramenta");
  };

  const fields: FormField[] = [
    {
      label: "Nome da Ferramenta",
      type: "text",
      value: nomeFerramenta,
      required: true,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setNomeFerramenta(e.target.value),
    },
    {
      label: "Nome Token da Ferramenta",
      type: "text",
      value: nomeTokenFerramenta,
      required: true,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setNomeTokenFerramenta(e.target.value),
    },
    {
      label: "Habilidade da Ferramenta",
      type: "text",
      value: habilidadeFerramenta,
      required: true,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setHabilidadeFerramenta(e.target.value),
    },
  ];

  return (
    <>
      <Formulario
        title="Editar Ferramenta"
        fields={fields}
        onSubmit={handleSubmit}
        onBack={handleBack}
        loading={loading || updating}
      />
      <>
        <Box sx={{ p: 3 }}>
          <Typography variant="h6">Empresas Cadastradas:</Typography>
          {empresas.length === 0 ? (
            <Typography variant="body1">Nenhuma empresa cadastrada.</Typography>
          ) : (
            <TableContainer component={Box} sx={{ maxHeight: 400 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>CNPJ</TableCell>
                    <TableCell>Nome</TableCell>
                    <TableCell>Pivot ID Empresa</TableCell>
                    <TableCell>Pivot ID Ferramenta</TableCell>
                    <TableCell>Pivot Ativo Empresa Ferramenta</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {empresas.map((empresa: todaEmpresa) => (
                    <TableRow key={empresa.id}>
                      <TableCell>{empresa.id}</TableCell>
                      <TableCell>{empresa.cnpj_empresa}</TableCell>
                      <TableCell>{empresa.nome_empresa}</TableCell>
                      <TableCell>{empresa.pivot.id_empresa}</TableCell>
                      <TableCell>{empresa.pivot.id_ferramenta}</TableCell>
                      <TableCell>
                        {empresa.pivot.ativo_empresa_ferramenta}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </>
    </>
  );
};

export default EditarFerramenta;
